import { TemplateRef } from '@angular/core';
import { PersonGroupsModel } from '@models/person-groups.model';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';

export interface CreateSharedWithOrgsTableConfigDependencies {
  actionsCell: TemplateRef<CellTemplateContext<PersonGroupsModel.PersonGroupSharedWithRow>>;
}

export function createSharedWithTableConfig(
  dependencies: CreateSharedWithOrgsTableConfigDependencies,
): DatasetTableConfig<PersonGroupsModel.PersonGroupSharedWithRow> {
  const builder = new ColumnBuilder<PersonGroupsModel.PersonGroupSharedWithRow>();

  return new TableConfigBuilder<PersonGroupsModel.PersonGroupSharedWithRow>()
    .columns([
      textColumn<PersonGroupsModel.PersonGroupSharedWithRow>(
        'orgName',
        'PERSON_GROUPS.SHARE_DIALOG.TABLE.ORGANIZATION',
        {
          width: 'minmax(180px, 1fr)',
          mobileVisible: true,
        },
      ),
      builder
        .column('accessType')
        .label('PERSON_GROUPS.SHARE_DIALOG.TABLE.ACTIONS')
        .width('minmax(200px, 260px)')
        .cellTemplate(dependencies.actionsCell)
        .mobileVisible()
        .build(),
    ])
    .rowHeight(44)
    .trackBy('orgId')
    .build();
}
